import * as DialogPrimitive from "@radix-ui/react-dialog"

import { useI18n } from "@/shared/i18n"
import { NftReward, PriceBadge } from "@/shared/ui"

import { PROMOCODE_REWARD_PRICE_TON_ICON_SIZE_PX } from "./PromocodeRewardDialog.config"
import { promocodeRewardDialogStyles as s } from "./PromocodeRewardDialog.styles"
import type { PromocodeRewardDialogProps } from "./PromocodeRewardDialog.types"

export function PromocodeRewardDialog({
  open,
  onOpenChange,
  imageUrl,
  lottieUrl,
  giftName,
  amount,
  wagerRequirement,
  onPlay,
}: PromocodeRewardDialogProps) {
  const { t } = useI18n()

  const handlePlay = () => {
    if (onPlay) onPlay()
    else onOpenChange(false)
  }

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className={s.overlay} />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className={s.content}
        >
          <div className={s.graphic}>
            <NftReward
              imageUrl={imageUrl}
              lottieUrl={lottieUrl}
              alt={giftName}
              size="lg"
              badge={
                Number(amount) > 0 ? (
                  <PriceBadge
                    value={amount}
                    iconSize={PROMOCODE_REWARD_PRICE_TON_ICON_SIZE_PX}
                  />
                ) : undefined
              }
            />
          </div>

          <div className={s.contentWrapper}>
            <div className={s.body}>
              <div className={s.titleBlock}>
                <DialogPrimitive.Title className={s.title}>
                  {t("promocodeReward.title")}
                </DialogPrimitive.Title>
                <p className={s.giftName}>{giftName}</p>
              </div>
              <div className={s.textBlock}>
                <p className={s.description}>
                  {t("promocodeReward.description")}
                </p>
                {wagerRequirement ? (
                  <p className={s.wagerRequirement}>{wagerRequirement}</p>
                ) : null}
              </div>
            </div>
            <div className={s.ctaWrapper}>
              <button type="button" onClick={handlePlay} className={s.cta}>
                {t("promocodeReward.cta")}
              </button>
            </div>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
